import React, { FC } from 'react'
import styled from 'styled-components'

const Container: FC<{ className?: string }> = ({ children, className }) => (
  <div className={className}>{children}</div>
)

Container.defaultProps = {
  className: '',
}

const StyledContainer = styled(Container)`
  background: ${({ theme }) => theme.colors.grayscale.white};
  display: flex;
  flex-wrap: nowrap;
  @media print {
    hr {
      max-width: unset;
    }
  }
`

export default StyledContainer
